module.exports = __webpack_public_path__ + "img/21ne.f1b618a5.svg";